export const services = {
  // Airport Transfers
  airportTransfers: 'Airport Transfers',
  airportTransfersDesc: 'Premium shuttle service to and from all airports in Morocco and Canada.',
  airportTransfersFeatures: [
    'Guaranteed punctuality',
    'Air-conditioned vehicles',
    'Professional drivers'
  ],
  airportTransfersDetailDesc: 'Our airport transfer service guarantees you a comfortable and stress-free journey. Our professional drivers welcome you with a name board and take care of your luggage.',
  airportTransfersIncluded: [
    'Real-time flight tracking',
    'Recent Mercedes and BMW vehicles',
    'Water and refreshments on board',
    'Free WiFi in all vehicles',
    'Concierge service',
    '24/7 assistance'
  ],
  airports: ['Mohammed V - Casablanca', 'Marrakech Menara', 'Agadir Al Massira', 'Fès Saïs', 'Montreal-Trudeau', 'Toronto Pearson'],
  
  // Tourist Circuits
  touristCircuits: 'Tourist Circuits',
  touristCircuitsDesc: 'Explore the wonders of Morocco with our personalized circuits and expert guides.',
  touristCircuitsFeatures: [
    'Tailor-made itineraries',
    'Multilingual guides',
    'Authentic discoveries'
  ],
  touristCircuitsDetailDesc: 'Discover authentic Morocco with our tailor-made circuits. From the medina of Fez to the dunes of Merzouga, each itinerary is designed to offer you an unforgettable experience.',
  touristCircuitsIncluded: [
    'Certified multilingual guide',
    'Air-conditioned 4x4 vehicle',
    'Accommodation in riads and Berber camps',
    'Traditional meals included',
    'Cultural activities',
    'Professional photos'
  ],
  destinations: ['Merzouga Desert', 'Dadès Valley', 'Aït Benhaddou', 'Chefchaouen', 'Essaouira', 'Atlas Mountains'],
  
  // Crew Transport
  crewTransport: 'Airline Crew Transport Service',
  crewTransportDesc: 'Specialized service for cabin crew and flight personnel.',
  crewTransportFeatures: [
    'Cabin crew transport',
    'Flexible schedules',
    'Professional service'
  ],
  crewTransportDetailDesc: 'Our specialized service is aimed at cabin crew and flight personnel. We understand the time constraints and specific needs of the aviation sector.',
  crewTransportIncluded: [
    'Transport adapted to flight schedules',
    'Comfortable vehicles for rest',
    '24/7 service for all time slots',
    'Drivers trained for cabin crew needs',
    'Real-time flight schedule tracking',
    'Preferential rates for airlines'
  ],
  occasions: ['Crews on layover', 'Flight personnel', 'Cabin crew at rest', 'Hotel-airport transfers', 'Airline services'],
  
  // Day Excursions
  dayExcursions: 'Day Excursions',
  dayExcursionsDesc: 'Discover iconic sites during unforgettable day excursions.',
  dayExcursionsFeatures: [
    'Early departure',
    'Must-see sites',
    'Comfortable return'
  ],
  dayExcursionsDetailDesc: 'Perfect for discovering Morocco\'s treasures in one day. Our excursions combine historical sites, natural landscapes and authentic cultural experiences.',
  dayExcursionsIncluded: [
    'Round-trip transport',
    'Experienced local guide',
    'Traditional lunch',
    'Tourist site entries',
    'Mint tea break',
    'Free time for shopping'
  ],
  dayDestinations: ['Ouzoud Waterfalls', 'Ourika Valley', 'Essaouira', 'Aït Benhaddou', 'Imlil', 'Ouarzazate'],
  
  // Chauffeur Service
  chauffeurService: 'Chauffeur Rental',
  chauffeurServiceDesc: 'Premium vehicles with experienced drivers for your free movements.',
  chauffeurServiceFeatures: [
    'Total flexibility',
    'Transparent rates',
    '24/7 availability'
  ],
  chauffeurServiceDetailDesc: 'Rent a vehicle with driver for total freedom in your movements. Ideal for extended stays or business trips.',
  chauffeurServiceIncluded: [
    'Recent and maintained vehicle',
    'Professional bilingual driver',
    'Fuel included',
    'Comprehensive insurance',
    '24/7 roadside assistance',
    'Daily vehicle cleaning'
  ],
  vehicles: ['Comfort sedans', '7-seater SUVs', '15-seater minibuses', 'Luxury vehicles'],
  
  // Canada Services
  canadaServices: 'Canada Services',
  canadaServicesDesc: 'Extension of our premium services to Canada for your North American travels.',
  canadaServicesFeatures: [
    'Montreal & Toronto',
    'Winter circuits',
    'Canadian experience'
  ],
  canadaServicesDetailDesc: 'Discover Canada with the same level of premium service. Our local partners offer you an authentic experience in Canada\'s most beautiful cities.',
  canadaServicesIncluded: [
    'Vehicles adapted to Canadian climate',
    'Native French-speaking guides',
    'Urban and nature circuits',
    'Unique winter experiences',
    'Boutique hotel accommodation',
    'Local culinary specialties'
  ],
  cities: ['Montreal', 'Toronto', 'Quebec', 'Ottawa', 'Niagara Falls', 'Mont-Tremblant']
};